module.exports = __webpack_public_path__ + "static/media/purga-01.97e8de11.jpg";